import { exposureChip, exposureChipLabel, exposureChipValue } from './exposure-tone.css.ts'
import { coerceInternetFacing } from './threat-model-report.tsx'

/**
 * How reachable the system is from untrusted networks, as one chip both graphs render identically.
 *
 * The label stays neutral and the value carries the tone, so "Internet-facing: **Partial**" reads as a
 * fact with an answer rather than as a warning about the whole phrase. It is a component rather than two
 * spans at each call site because the two graphs sit one tab apart, and this chip has drifted before.
 *
 * The value shown is the document's own wording, capitalised — not the coerced bucket. The tone is
 * coerced, so an unrecognised answer still gets a neutral chip instead of an unstyled one, but the
 * reader sees what the model actually said.
 */
export type ExposureChipProps = { internetFacing: string }

export const ExposureChip: React.FC<ExposureChipProps> = ({ internetFacing }) => {
  const tone = coerceInternetFacing(internetFacing)
  const trimmed = internetFacing.trim()
  const value = trimmed.length > 0 ? `${trimmed[0]?.toUpperCase()}${trimmed.slice(1)}` : 'Unknown'

  return (
    <span className={exposureChip({ internetFacing: tone })}>
      <span className={exposureChipLabel}>Internet-facing:</span>
      <span className={exposureChipValue({ internetFacing: tone })}>{value}</span>
    </span>
  )
}
